module.exports = __webpack_public_path__ + "img/yoshi-min.abab98f7.png";